import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import MainApp from "../../layouts/MainApp";
import { adminActions } from "../../../redux/actions";

export default function Settings() {
  // let user = JSON.parse(localStorage.getItem("user"));
  // let teamId = JSON.parse(localStorage.getItem("teamId"));

  // let isCompany = user.data.team_roles[teamId].roles.includes("company");

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(adminActions.getThirdPartyToken());
  }, [dispatch]);

  return (
    <MainApp>
      <div className="main-content-padding">
        <div className="main-content">
          <div className="mb-2  d-flex justify-content-between ">
            <h1 className="mr-2">Settings</h1>
          </div>
          <div className="separator-breadcrumb border-top" />

          <div className="row">
            <Link
              to={"/settings/third-party-token"}
              className="text-decoration-none"
            >
              <div
                className="card mt-5 ml-2"
                style={{ width: "343px", height: "180px" }}
              >
                <div className="card-body">
                  <h2 className="card-title mt-3">Third party token</h2>

                  <p className="card-text">
                    This allows a third party to create and edit orders for your
                    company using the generated token.
                  </p>
                </div>
              </div>
            </Link>
            <Link
              to={"/settings/assign-roles"}
              className="text-decoration-none"
            >
              <div
                className="card mt-5 ml-4"
                style={{ width: "343px", height: "180px" }}
              >
                <div className="card-body">
                  <h2 className="card-title mt-3">Assign roles</h2>

                  <p className="card-text">
                    This admin to assign roles and responsibilities to
                    employees.
                  </p>
                </div>
              </div>
            </Link>
            <Link to={"/settings/application"} className="text-decoration-none">
              <div
                className="card mt-5 ml-4"
                style={{ width: "343px", height: "180px", cursor: "pointer" }}
              >
                <div className="card-body">
                  <h2 className="card-title mt-3">Application Settings</h2>

                  <p className="card-text">
                    Update application settings and company settings.
                  </p>
                </div>
              </div>
            </Link>

            <Link
              to="/settings/publish-subscribe"
              className="text-decoration-none"
            >
              <div
                className="card mt-5 ml-4"
                style={{ width: "343px", height: "180px", cursor: "pointer" }}
              >
                <div className="card-body">
                  <h2 className="card-title mt-3">Publish and subscribe</h2>

                  <p className="card-text">
                    Check prices for your orders and delivery.
                  </p>
                </div>
              </div>
            </Link>
          </div>
          <div className="mb-4">
            {/* <h3 className="mb-3">Third party token</h3>

              <h5 className="mb-3">
                This allows a third party to create and edit orders for your
                company using the generated token{" "}
              </h5>
              <br></br>
              <div className="mb-4">
                <MDBDataTable
                  responsive
                  searching={false}
                  entries={5}
                  entriesOptions={[5, 8, 15]}
                  striped
                  bordered
                  hover
                  noBottomColumns
                  data={data}
                />
              </div> */}

            {/* 
              {isCompany && (
                <div>
                  <h3 className='mb-3'>Abilities</h3>
                  <a href='/settings/ability/1' className='btn btn-primary'>
                    Assign abilities
                  </a>
                </div>
              )} */}

            {/* <AssignRole /> */}
          </div>
          {/* end of row*/}
          {/* end of main-content */}
        </div>
      </div>
    </MainApp>
  );
}
